export const isBriefPage = page => page === 'brief'

export const getCurrentPage = pathname => {
  return pathname.split('/').pop()
}
